/** Rail icon for Market Teams (inline SVG, eager and tiny): a team pennant on a pole. Atlas art: sharedRequests `ico_team`. */
import type { JSX } from 'preact';

const ink = '#5a2e1f';

export function TeamIcon({ size = 26 }: { size?: number }): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <path d="M7 3v26" stroke={ink} stroke-width="3" stroke-linecap="round" />
      <path d="M8.5 5h17l-4 6 4 6h-17z" fill="#ff6b5b" stroke={ink} stroke-width="2.4" stroke-linejoin="round" />
      <path d="M15 8.2l1.2 2.4 2.6.3-1.9 1.8.5 2.6-2.4-1.3-2.4 1.3.5-2.6-1.9-1.8 2.6-.3z" fill="#ffc845" stroke={ink} stroke-width="1" stroke-linejoin="round" />
      <circle cx="7" cy="3.5" r="2.2" fill="#ffc845" stroke={ink} stroke-width="1.6" />
    </svg>
  );
}
